var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 100,
    fill: "#4FB0FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6225_20191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.779 124.061L99.5292 140.936C99.3242 141.243 99.0607 141.507 98.7536 141.713C98.4466 141.919 98.1021 142.062 97.7397 142.134C97.0079 142.281 96.2479 142.13 95.6269 141.716C95.0059 141.302 94.5748 140.659 94.4284 139.927C94.2821 139.195 94.4324 138.435 94.8464 137.814L106.096 120.939C106.51 120.318 107.154 119.887 107.886 119.741C108.618 119.594 109.378 119.745 109.999 120.159C110.62 120.573 111.051 121.216 111.197 121.948C111.344 122.68 111.193 123.44 110.779 124.061ZM136.517 85.7793C136.118 78.9525 133.116 72.5386 128.13 67.8583C123.145 63.1779 116.554 60.5875 109.715 60.6204C102.877 60.6533 96.3115 63.307 91.3709 68.035C86.4302 72.7631 83.4904 79.2056 83.157 86.0359C83.1159 86.7648 82.7992 87.4508 82.2711 87.9548C81.7429 88.4588 81.0428 88.7431 80.3128 88.75H80.1019C79.3594 88.6836 78.6722 88.3302 78.1863 87.7649C77.7004 87.1996 77.4543 86.467 77.5003 85.723C77.598 83.7675 77.8722 81.8249 78.3195 79.9187C78.3772 79.6794 78.371 79.4291 78.3016 79.1929C78.2323 78.9567 78.1021 78.7428 77.9241 78.5727C77.7462 78.4025 77.5267 78.2821 77.2876 78.2234C77.0485 78.1647 76.7981 78.1699 76.5616 78.2383C72.7545 79.3631 69.416 81.6945 67.049 84.8814C64.682 88.0683 63.4146 91.9381 63.4378 95.9078C63.5081 106.001 71.9175 114.062 82.0144 114.062H94.7445L86.4089 126.564C85.9949 127.185 85.8446 127.945 85.9909 128.677C86.1373 129.409 86.5684 130.052 87.1894 130.466C87.8104 130.88 88.5704 131.031 89.3022 130.884C90.034 130.738 90.6777 130.307 91.0917 129.686L101.505 114.062H109.844C113.483 114.058 117.084 113.312 120.424 111.868C123.765 110.424 126.776 108.314 129.273 105.667C131.77 103.019 133.7 99.8895 134.946 96.4699C136.192 93.0504 136.726 89.4126 136.517 85.7793Z",
    fill: "#272727"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6225_20191"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 90,
    fill: "white",
    transform: "translate(55 55)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRain);
export default __webpack_public_path__ + "static/media/rain.2e95dc6793b2a7d948c84014ad110eba.svg";
export { ForwardRef as ReactComponent };